exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".issue-dropdown[data-v-1c92b32a]{box-shadow:0 4px 22px rgba(55,54,77,.15)}#arrow[data-v-1c92b32a],#arrow[data-v-1c92b32a]:before{position:absolute;width:8px;height:8px;z-index:-1}#arrow[data-v-1c92b32a]:before{--tw-bg-opacity:1;background-color:rgba(250,250,250,var(--tw-bg-opacity));content:\"\";transform:rotate(45deg)}[data-popper-placement^=top]>#arrow[data-v-1c92b32a]{bottom:-4px}[data-popper-placement^=bottom]>#arrow[data-v-1c92b32a]{top:-4px}[data-popper-placement^=left]>#arrow[data-v-1c92b32a]{right:-4px}[data-popper-placement^=right]>#arrow[data-v-1c92b32a]{left:-4px}", ""]);

// exports
